export const setActiveSection = (state, activeSection) => state.section = activeSection
export const setLanguage = (state, lang) => state.lang = lang
export const setHeaderHeight = (state, header) => state.header = header